import { render } from "./DistributionLists.vue?vue&type=template&id=da2806e8"
import script from "./DistributionLists.vue?vue&type=script&lang=js"
export * from "./DistributionLists.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__